/**
 * SF-4729: what sf-api answered for each transcript file sent to a build: read (with its note,
 * e.g. that only the first part of a long file was used) or refused, with the reason.
 */
import { List, Tag } from 'antd';
import type { TranscriptResult } from '../api/demoBuildsClient';
import { transcriptOutcome } from '../transcripts';

export const TRANSCRIPT_OUTCOMES_LABEL = 'What happened to each transcript';

export const TranscriptOutcomes: React.FC<{ outcomes: TranscriptResult[] }> = ({ outcomes }) =>
  outcomes.length === 0 ? null : (
    <section aria-label={TRANSCRIPT_OUTCOMES_LABEL}>
      <List
        size="small"
        bordered
        dataSource={outcomes}
        renderItem={(t) => {
          const o = transcriptOutcome(t);
          return (
            <List.Item>
              <List.Item.Meta title={t.name} description={o.detail} />
              <Tag color={o.color}>{o.label}</Tag>
            </List.Item>
          );
        }}
      />
    </section>
  );
